"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentFilters = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var sortedUniqBy_1 = __importDefault(require("lodash/sortedUniqBy"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var hooks_1 = require("../../../api/hooks");
var Icon_1 = require("../Icon/Icon");
var constants_1 = require("../../../api/constants");
var DpAssessmentFilters_styled_1 = require("./DpAssessmentFilters.styled");
var AssessmentsFilterCriteria_1 = require("./AssessmentsFilterCriteria");
var api_1 = require("../../../api");
var lodash_1 = require("lodash");
var Select_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Select/Select.component");
var SelectOption_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Select/SelectOption.component");
var Button_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Button/Button.component");
var DpAssessmentFilters = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var disabled = _a.disabled, filterHandler = _a.filterHandler, languageFilterHandler = _a.languageFilterHandler, curriculums = _a.curriculums, isAdmin = _a.isAdmin, _q = _a.hasEquipLicense, hasEquipLicense = _q === void 0 ? false : _q, _r = _a.sticky, sticky = _r === void 0 ? false : _r;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var userPreferencesService = (0, react_1.useContext)(api_1.ServiceContext).userPreferencesService;
    // ----------------------------------------- State and Props
    var _s = (0, react_1.useState)({
        curriculumOptions: [],
        gradesOptions: [],
        modulesOptions: [],
        topicsOptions: [],
        assessmentTypeOptions: [],
    }), filters = _s[0], setFilters = _s[1];
    var _t = (0, react_1.useState)(false), filtering = _t[0], setFiltering = _t[1];
    var _u = (0, react_1.useState)(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria()), filterCriteria = _u[0], setFilterCriteria = _u[1];
    // ----------------------------------------- Methods
    var uniqueSortedOptions = function (options) {
        return (0, sortedUniqBy_1.default)((0, sortBy_1.default)(options, 'id'), 'id');
    };
    var uniqueOptions = function (options) { return (0, uniqBy_1.default)(options, 'id'); };
    var getFilterDropDownOptions = function (elements, criteria) {
        return elements.map(function (element) { return ({
            id: element.id,
            title: element.name,
            selected: criteria.includes(element.id),
        }); });
    };
    var getSelectedOptions = function (elements, criteria) { return elements.filter(function (_a) {
        var id = _a.id;
        return criteria.includes(id);
    }); };
    var switchOptions = (0, react_1.useMemo)(function () { return [
        {
            id: constants_1.LANGUAGES.English,
            title: t('assessmentFilters.englishPlaceHolder'),
            selected: filterCriteria.language === constants_1.LANGUAGES.English,
        },
        {
            id: constants_1.LANGUAGES.Spanish,
            title: t('assessmentFilters.spanishPlaceHolder'),
            selected: filterCriteria.language === constants_1.LANGUAGES.Spanish,
        },
    ]; }, [t, filterCriteria]);
    var getAssessmentTypeOptionsEM = (0, react_1.useCallback)(function (criteria) {
        var assessmentTypeOptions = [
            {
                id: constants_1.AssessmentType.Assessment,
                title: t('assessmentTypeValues.assessment'),
                selected: criteria.assessmentType.includes(constants_1.AssessmentType.Assessment),
            },
        ];
        if (isAdmin || hasEquipLicense) {
            assessmentTypeOptions.push({
                id: constants_1.AssessmentType.Diagnostic,
                title: t('assessmentTypeValues.diagnostic'),
                selected: criteria.assessmentType.includes(constants_1.AssessmentType.Diagnostic),
            });
        }
        return assessmentTypeOptions;
    }, [t, isAdmin, hasEquipLicense]);
    var getAssessmentTypeOptionsWW = (0, react_1.useCallback)(function (criteria) {
        var assessmentTypeOptions = [
            {
                id: constants_1.AssignmentType.FQT,
                title: t('assessmentTypeValues.fqt'),
                selected: criteria.assignmentType.includes(constants_1.AssignmentType.FQT),
            },
            {
                id: constants_1.AssignmentType.WWEOM,
                title: t('assessmentTypeValues.eom'),
                selected: criteria.assignmentType.includes(constants_1.AssignmentType.WWEOM),
            },
            {
                id: constants_1.AssignmentType.NR,
                title: t('assessmentTypeValues.nr'),
                selected: criteria.assignmentType.includes(constants_1.AssignmentType.NR),
            },
            {
                id: constants_1.AssignmentType.QuestionSet,
                title: t('assessmentTypeValues.qs'),
                selected: criteria.assignmentType.includes(constants_1.AssignmentType.QuestionSet),
            },
            {
                id: constants_1.AssignmentType.Vocabulary,
                title: t('assessmentTypeValues.vocabulary'),
                selected: criteria.assignmentType.includes(constants_1.AssignmentType.Vocabulary),
            },
        ];
        return assessmentTypeOptions;
    }, [t]);
    var setFiltersOptions = (0, react_1.useCallback)(function (criteria) {
        // Initialize arrays to store different types of options and selected items
        var curriculumOptions = [];
        var gradeOptions = [];
        var modulesOptions = [];
        var topicsOptions = [];
        var selectedCurriculum = [];
        var selectedGrades = [];
        var selectedModules = [];
        // Generate dropdown options for curriculums and get selected curriculums
        curriculumOptions = curriculumOptions.concat(getFilterDropDownOptions(curriculums, criteria.curriculums));
        selectedCurriculum = selectedCurriculum.concat(getSelectedOptions(curriculums, criteria.curriculums));
        // If there are selected curriculums, generate grade options for each curriculum
        if (!(0, isEmpty_1.default)(selectedCurriculum)) {
            selectedCurriculum.forEach(function (curriculum) {
                // Add grade options for this curriculum
                gradeOptions = gradeOptions.concat(getFilterDropDownOptions(curriculum.grades, criteria.grades));
                // Track which grades are selected
                selectedGrades = selectedGrades.concat(getSelectedOptions(curriculum.grades, criteria.grades));
            });
        }
        // If there are selected grades, generate module options for each grade
        if (!(0, isEmpty_1.default)(selectedGrades)) {
            selectedGrades.forEach(function (grade) {
                // Add module options for this grade
                modulesOptions = modulesOptions.concat(getFilterDropDownOptions(grade.modules, criteria.modules));
                // Track which modules are selected
                selectedModules = selectedModules.concat(getSelectedOptions(grade.modules, criteria.modules));
            });
        }
        // If there are selected modules, generate topic options for each module
        if (!(0, isEmpty_1.default)(selectedModules)) {
            selectedModules.forEach(function (module) {
                // Add topic options for this module
                topicsOptions = topicsOptions.concat(getFilterDropDownOptions(module.topics, criteria.topics));
            });
        }
        var witAndWisdomCurriculum = criteria.hasCurriculumWitAndWisdom();
        // Update the filters state with all generated options
        // Note: uniqueSortedOptions ensures options are unique and sorted
        // uniqueOptions only ensures uniqueness (used for grades which may not need sorting)
        setFilters({
            curriculumOptions: uniqueSortedOptions(curriculumOptions),
            gradesOptions: uniqueOptions(gradeOptions),
            modulesOptions: uniqueSortedOptions(modulesOptions),
            topicsOptions: uniqueSortedOptions(topicsOptions),
            // Fetch and add assessment type options asynchronously
            assessmentTypeOptions: witAndWisdomCurriculum
                ? getAssessmentTypeOptionsWW(criteria)
                : getAssessmentTypeOptionsEM(criteria),
        });
    }, 
    // Dependencies for useCallback
    [curriculums, setFilters, getAssessmentTypeOptionsEM, getAssessmentTypeOptionsWW]);
    var saveFilters = (0, react_1.useCallback)(function (criteria) {
        if (!sticky)
            return;
        var filters = __assign({}, criteria);
        var keys = Object.keys(filters);
        keys.forEach(function (key) {
            var _a;
            if (!((_a = filters[key]) === null || _a === void 0 ? void 0 : _a.length)) {
                delete filters[key];
            }
        });
        userPreferencesService.setUserPreferences(constants_1.PreferenceKey.GM_LIBRARY_FILTERS, filters, constants_1.PLATFORM.InSync);
    }, [userPreferencesService, sticky]);
    var debounceSaveFilters = (0, react_1.useMemo)(function () { return (0, lodash_1.debounce)(saveFilters, 500); }, [saveFilters]);
    var filter = function (criteria) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFiltering(true);
                    setFilterCriteria(criteria);
                    setFiltersOptions(criteria);
                    debounceSaveFilters(criteria);
                    return [4 /*yield*/, filterHandler(criteria)];
                case 1:
                    _a.sent();
                    setFiltering(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var filterBySubject = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var curriculum;
        return __generator(this, function (_a) {
            curriculum = selectedOptions.map(function (subject) { return subject.id; });
            filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                curriculums: curriculum,
                assessmentType: filterCriteria.assessmentType,
                assignmentType: filterCriteria.assignmentType,
                language: filterCriteria.language,
            }));
            return [2 /*return*/];
        });
    }); };
    var filterByGrade = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOption;
        return __generator(this, function (_a) {
            selectedOption = selectedOptions[0];
            filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                curriculums: filterCriteria.curriculums,
                grades: [selectedOption.id],
                assessmentType: filterCriteria.assessmentType,
                assignmentType: filterCriteria.assignmentType,
                language: filterCriteria.language,
            }));
            return [2 /*return*/];
        });
    }); };
    var filterByModule = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOption;
        return __generator(this, function (_a) {
            selectedOption = selectedOptions[0];
            filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                curriculums: filterCriteria.curriculums,
                grades: filterCriteria.grades,
                modules: [selectedOption.id],
                assessmentType: filterCriteria.assessmentType,
                assignmentType: filterCriteria.assignmentType,
                language: filterCriteria.language,
            }));
            return [2 /*return*/];
        });
    }); };
    var filterByAssessmentType = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOption, assessmentOrAssignmentTypes, isAssessmentFilter;
        return __generator(this, function (_a) {
            selectedOption = selectedOptions[0];
            assessmentOrAssignmentTypes = [selectedOption.id];
            isAssessmentFilter = (0, isEmpty_1.default)(filterCriteria.curriculums) ||
                filterCriteria.curriculums[0].startsWith(constants_1.CurriculumId.EurekaMath);
            filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                curriculums: filterCriteria.curriculums,
                grades: filterCriteria.grades,
                modules: filterCriteria.modules,
                topics: filterCriteria.topics,
                language: filterCriteria.language,
                assessmentType: isAssessmentFilter
                    ? assessmentOrAssignmentTypes
                    : filterCriteria.assessmentType,
                assignmentType: !isAssessmentFilter
                    ? assessmentOrAssignmentTypes
                    : filterCriteria.assignmentType,
            }));
            return [2 /*return*/];
        });
    }); };
    var filterByTopic = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOption;
        return __generator(this, function (_a) {
            selectedOption = selectedOptions[0];
            filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                curriculums: filterCriteria.curriculums,
                grades: filterCriteria.grades,
                modules: filterCriteria.modules,
                topics: [selectedOption.id],
                assessmentType: filterCriteria.assessmentType,
                language: filterCriteria.language,
            }));
            return [2 /*return*/];
        });
    }); };
    var filterByLanguage = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOption, criteria;
        return __generator(this, function (_a) {
            selectedOption = selectedOptions[0];
            languageFilterHandler(selectedOption.id);
            criteria = new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria(__assign(__assign({}, filterCriteria), { language: selectedOption.id }));
            setFilterCriteria(criteria);
            debounceSaveFilters(criteria);
            return [2 /*return*/];
        });
    }); };
    var resetFilters = function () {
        filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria());
        languageFilterHandler('');
    };
    var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var savedFilters, _a, criteria;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!sticky) return [3 /*break*/, 2];
                    return [4 /*yield*/, userPreferencesService.getUserPreferences(constants_1.PreferenceKey.GM_LIBRARY_FILTERS, constants_1.PLATFORM.InSync)];
                case 1:
                    _a = (_b.sent()) || {};
                    return [3 /*break*/, 3];
                case 2:
                    _a = null;
                    _b.label = 3;
                case 3:
                    savedFilters = _a;
                    if (!savedFilters) return [3 /*break*/, 5];
                    criteria = new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria(savedFilters);
                    setFilterCriteria(criteria);
                    setFiltersOptions(criteria);
                    return [4 /*yield*/, filterHandler(criteria)];
                case 4:
                    _b.sent();
                    if (criteria.language) {
                        languageFilterHandler(criteria.language);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setFiltersOptions(filterCriteria);
                    debounceSaveFilters(filterCriteria);
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // ----------------------------------------- Hooks
    (0, hooks_1.useMount)(function () {
        initialize();
    });
    return ((0, jsx_runtime_1.jsxs)(DpAssessmentFilters_styled_1.StyledAssessmentFilters, { className: "filters", children: [(0, jsx_runtime_1.jsx)("div", { style: { width: '175px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-subject-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.subject'), labelProps: {
                        htmlFor: 'gm-library-subject-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.hasCurriculums()
                        ? (_b = filters.curriculumOptions.find(function (option) { return option.id === filterCriteria.curriculums[0]; })) === null || _b === void 0 ? void 0 : _b.title
                        : t('assessmentFilters.subject'), disabled: disabled || filtering, defaultIndex: ((_c = filterCriteria.curriculums) === null || _c === void 0 ? void 0 : _c.length)
                        ? filters.curriculumOptions.findIndex(function (option) { return option.id === filterCriteria.curriculums[0]; })
                        : -1, children: filters.curriculumOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterBySubject([{ id: option.id, title: option.title }]); }, "data-testid": "subject-option-".concat(index), children: option.title }) }, "subject-option-".concat(option.id))); }) }) }), (0, jsx_runtime_1.jsx)("div", { style: { width: '150px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-grades-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.gradeLevel'), labelProps: {
                        htmlFor: 'gm-library-grades-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.hasGrades()
                        ? (_d = filters.gradesOptions.find(function (option) { return option.id === filterCriteria.grades[0]; })) === null || _d === void 0 ? void 0 : _d.title
                        : t('assessmentFilters.gradeLevel'), disabled: !filterCriteria.hasCurriculums() || filtering, defaultIndex: ((_e = filterCriteria.grades) === null || _e === void 0 ? void 0 : _e.length)
                        ? filters.gradesOptions.findIndex(function (option) { return option.id === filterCriteria.grades[0]; })
                        : -1, children: filters.gradesOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterByGrade([{ id: option.id, title: option.title }]); }, "data-testid": "grade-option-".concat(index), children: option.title }) }, "grade-option-".concat(option.id))); }) }) }), (0, jsx_runtime_1.jsx)("div", { style: { width: '130px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-modules-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.module'), labelProps: {
                        htmlFor: 'gm-library-modules-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.hasModules()
                        ? (_f = filters.modulesOptions.find(function (option) { return option.id === filterCriteria.modules[0]; })) === null || _f === void 0 ? void 0 : _f.title
                        : t('assessmentFilters.module'), disabled: !filterCriteria.hasGrades() || filtering, defaultIndex: ((_g = filterCriteria.modules) === null || _g === void 0 ? void 0 : _g.length)
                        ? filters.modulesOptions.findIndex(function (option) { return option.id === filterCriteria.modules[0]; })
                        : -1, children: filters.modulesOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterByModule([{ id: option.id, title: option.title }]); }, "data-testid": "module-option-".concat(index), children: option.title }) }, "module-option-".concat(option.id))); }) }) }), filterCriteria.hasCurriculumEurekaMath() && ((0, jsx_runtime_1.jsx)("div", { style: { width: '130px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-topics-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.topic'), labelProps: {
                        htmlFor: 'gm-library-topics-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.hasTopics()
                        ? (_h = filters.topicsOptions.find(function (option) { return option.id === filterCriteria.topics[0]; })) === null || _h === void 0 ? void 0 : _h.title
                        : t('assessmentFilters.topic'), disabled: !filterCriteria.hasModules() || filtering, defaultIndex: ((_j = filterCriteria.topics) === null || _j === void 0 ? void 0 : _j.length)
                        ? filters.topicsOptions.findIndex(function (option) { return option.id === filterCriteria.topics[0]; })
                        : -1, children: filters.topicsOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterByTopic([{ id: option.id, title: option.title }]); }, "data-testid": "topic-option-".concat(index), children: option.title }) }, "topic-option-".concat(option.id))); }) }) })), (0, jsx_runtime_1.jsx)("div", { style: { width: '175px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-assignment-type-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.assessmentType'), labelProps: {
                        htmlFor: 'gm-library-assignment-type-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.hasCurriculumWitAndWisdom()
                        ? filterCriteria.hasAssignmentType() && filterCriteria.assignmentType.length > 0
                            ? (_k = filters.assessmentTypeOptions.find(function (option) { return option.id === filterCriteria.assignmentType[0]; })) === null || _k === void 0 ? void 0 : _k.title
                            : t('assessmentFilters.assessmentType')
                        : filterCriteria.hasAssessmentType() && filterCriteria.assessmentType.length > 0
                            ? (_l = filters.assessmentTypeOptions.find(function (option) { return option.id === filterCriteria.assessmentType[0]; })) === null || _l === void 0 ? void 0 : _l.title
                            : t('assessmentFilters.assessmentType'), disabled: !filterCriteria.hasCurriculums() || filtering, defaultIndex: filterCriteria.hasCurriculumWitAndWisdom()
                        ? ((_m = filterCriteria.assignmentType) === null || _m === void 0 ? void 0 : _m.length)
                            ? filters.assessmentTypeOptions.findIndex(function (option) { return option.id === filterCriteria.assignmentType[0]; })
                            : -1
                        : ((_o = filterCriteria.assessmentType) === null || _o === void 0 ? void 0 : _o.length)
                            ? filters.assessmentTypeOptions.findIndex(function (option) { return option.id === filterCriteria.assessmentType[0]; })
                            : -1, children: filters.assessmentTypeOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterByAssessmentType([{ id: option.id, title: option.title }]); }, "data-testid": "assessment-type-option-".concat(index), children: option.title }) }, "assessment-type-option-".concat(option.id))); }) }) }), (0, jsx_runtime_1.jsx)("div", { style: { width: '130px', marginLeft: 'var(--spacing-xs)' }, children: (0, jsx_runtime_1.jsx)(Select_component_1.Select, { id: "gm-library-language-filter", singleSelect: true, selectButtonSize: "small", showPlusIcon: false, responsiveLogo: true, labelText: t('assessmentFilters.language'), labelProps: {
                        htmlFor: 'gm-library-language-filter',
                    }, labelPosition: "top", placeholder: filterCriteria.language
                        ? (_p = switchOptions.find(function (option) { return option.id === filterCriteria.language; })) === null || _p === void 0 ? void 0 : _p.title
                        : t('assessmentFilters.language'), defaultIndex: filterCriteria.language
                        ? switchOptions.findIndex(function (option) { return option.id === filterCriteria.language; })
                        : -1, children: switchOptions.map(function (option, index) { return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SelectOption_component_1.SelectOption, { label: option.title, onClick: function () { return filterByLanguage([{ id: option.id, title: option.title }]); }, "data-testid": "language-option-".concat(index), children: option.title }) }, "language-option-".concat(option.id))); }) }) }), filterCriteria.isDirty() && ((0, jsx_runtime_1.jsx)("div", { className: "self-end mt-6", style: { marginLeft: '1.5rem' }, children: (0, jsx_runtime_1.jsxs)(Button_component_1.Button, { variant: "tertiary", onPress: resetFilters, testId: "reset-filters", children: [(0, jsx_runtime_1.jsx)(Button_component_1.Button.Icon, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "refresh" }) }), (0, jsx_runtime_1.jsx)(Button_component_1.Button.Label, { children: t('assessmentFilters.reset') })] }) }))] }));
};
exports.DpAssessmentFilters = DpAssessmentFilters;
